import script from "./ImageGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGallery.vue?vue&type=script&setup=true&lang=js"

import "./ImageGallery.vue?vue&type=style&index=0&id=4d8138cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d8138cd"]])

export default __exports__